export const UNSYNC_AD_SETS = "UNSYNC_AD_SETS";

export const RECONFIGURE_FACEBOOK = "RECONFIGURE_FACEBOOK";

export const SYNC_AD_SETS = "SYNC_AD_SETS";

export type FacebookEditAction = typeof SYNC_AD_SETS | typeof UNSYNC_AD_SETS | typeof RECONFIGURE_FACEBOOK;
